import React from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import ChangePasswordTab from "./Tabbed/changePasswordTab";
import PersonalInfo from "./Tabbed/PersonalInfo";
// css
import styles from "./MyProfile.module.scss";

const MyProfile = () => {
  return (
    <>
      <section className={`${styles.MyProfile} MyProfile`}>
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">Profile MyProfile</h3>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="cardCstm bg-white p-3 px-lg-4 rounded">
                <Tab.Container id="left-tabs-example" defaultActiveKey="PersonalInformation">
                  <Nav
                    variant="pills"
                    className="underlineTab border-bottom mb-3 "
                    style={{ maxWidth: "max-content" }}
                  >
                    <Nav.Item>
                      <Nav.Link
                        eventKey="PersonalInformation"
                        className="bg-transparent position-relative fw-sbold"
                      >
                        Personal Information
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="ChangePassword"
                        className="bg-transparent position-relative fw-sbold"
                      >
                        Change Password
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="PersonalInformation">
                      <PersonalInfo />
                    </Tab.Pane>
                    <Tab.Pane eventKey="ChangePassword">
                      <ChangePasswordTab />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default MyProfile;
